import { useRootStore } from './index';
import { action, observable } from 'mobx';
import { UpdateArticleInput, ArticleSettingsQuery_article as Article } from 'api';

export class EditArticleStore {
  @observable article: Article | undefined;
  @action setArticle = (article: Article) => (this.article = article);

  @observable attributes: UpdateArticleInput = {
    id: '',
    url: '',
    title: '',
    addtionalParameters: '',
    manualExpirationTime: null,
    targetingSelection: null,
    budgetCapDollars: null,
    goalCpcDollars: null,
    deprecated: null,
    starred: false,
    isPolitical: null,
    specialAdCategories: null,
    applicablePolicies: null,
    discountSettingsAttributes: null
  };
  @action setAttributes = (newAttributes: UpdateArticleInput) => (this.attributes = newAttributes);
}

export const useEditArticleStore = (): EditArticleStore => {
  const store = useRootStore();
  if (!store.editArticleStore) throw new Error('CT store has not been initialized');
  return store.editArticleStore;
};
